export function normalizePatch(patch: string) {
  const patchSplit = patch.split(".");
  if (patchSplit.length >= 2) {
    return `${patchSplit[0]}_${patchSplit[1]}`;
  }

  return patch;
}
